import React from "react";
import { Paper, Typography } from "@mui/material";

export const StatCard = ({ title, value, subtitle }) => (
  <Paper
    elevation={0}
    sx={{
      px: 1.5,
      py: 0.75,
      borderRadius: 1,
      border: "1px solid #e0e0e0",
      bgcolor: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
    }}
  >
    <Typography variant="body2" sx={{ color: "#5f6368", fontWeight: 500 }}>
      {title}
    </Typography>
    <Typography variant="h6" fontWeight={600} sx={{ color: "#202124", lineHeight: 1 }}>
      {value}
    </Typography>
    <Typography variant="body2" sx={{ color: "#9aa0a6" }}>
      {subtitle}
    </Typography>
  </Paper>
);